export default __webpack_public_path__ + "static/media/ursu.279ccbe7.jpg";